var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"home-timeline"},_vm._l((_vm.fonum),function(item,index){return _c('home-timeline-item',{key:index,attrs:{"spl":_vm.spl,"isacolor":_vm.isacolor}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }